import { type MenuGroup } from './MenuGroup.tsx';
import { MenuPresets } from './MenuPresets.tsx';

export interface IResolveRichTextMenusOptions {
  /** Gruppi richiesti dal chiamante (prop `menus` di RichTextInput). */
  menus: MenuGroup[] | undefined;
  /** Valore osservato del campo indicato da `rteItemTypeFieldName`. */
  fieldType?: unknown;
  /** Gruppi esclusi dal RichTextMenuScopeContext. */
  exclude?: MenuGroup[];
}

/**
 * Calcola i gruppi di pulsanti effettivamente disponibili per un editor rich
 * text
 */
export function resolveRichTextMenus(
  options: IResolveRichTextMenusOptions,
): MenuGroup[] | undefined {
  const { menus, fieldType, exclude } = options;

  const resolved: MenuGroup[] | undefined =
    fieldType === 'info' ? MenuPresets.Block : menus;

  if (resolved == null || !exclude?.length) return resolved;

  return resolved.filter(menu => !exclude.includes(menu));
}
